<template>
    <div class="FristView publicViewClass" style="padding-top:0">
        <div class="edit-step" v-if="!importTopic">
            <topicSteps :active = "1" :propList="propList"></topicSteps>
        </div>
        <div class="importTopic" v-if="!importTopic">
            <el-upload 
            ref="upload"
            accept=".xls,.xlsx" drag  
            :limit="1"  
            :auto-upload="true" 
             :action="$config.baseUrl + '/platform/emuPaper/step/importExcel?paperId=' + $route.query.id" 
              :headers="headers"
             :on-success="handleSuccess" >
                <i class="icon-al-file-fill"></i>
                <div class="el-upload__text">
                   请将文件拖拽到此区域上传，或<em>选择文件上传</em>
                </div>
                 <div class="el-upload__tip" slot="tip">仅支持excel文件</div>
               <el-button size="small" type="primary">选择文件</el-button>
            </el-upload>
            <div class="template-text" @click="openExcel">
                <div class="excel-icon"></div>
                下载Excel过程步骤模版
            </div>
            <div class="template-text" @click="returnStep">
                返回配置步骤
            </div>
         <div class="tips-text">
                <div class="title">导入说明</div>
                <p>1.建议按多次分批导入。</p>
                <p>2.推荐使用微软Office编辑</p>
            </div>
        </div>
         <div class="edit-step" v-if="importTopic">
            <topicSteps :active = "2" :propList="propList"></topicSteps>
        </div>
        <div class="app-inner show_container" style="padding:16px 0 !important;margin-bottom:80px"  v-if="importTopic">
           <div class="public-btn-small flex align-cen posta enposta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="cacelIM">
                取消导入
            </div>
           <el-button type="primary"  :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
           @click="stepSave"
            >
             导入
           </el-button>
            </div>
               <div class="question-duplication-container staff_manage_center">
                 <div class="public-list-container-table">
                <el-table
                    :data="itemList"
                    border
                    style="width: 100%"
                    :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                    >
                    <el-table-column label="" align="center"   width="150">
                     <template slot-scope="scope" >
                                <div class="handle_move">
                                <i  class="icon-al-arrows-alt"  style="font-size:22px"/>
                            </div>
                       </template>
                   </el-table-column>
                        <el-table-column prop="sort" label="序号" align="center" width="150">
                        </el-table-column>
                        <el-table-column prop="stepName" label="步骤名称" align="center" width="150">
                        </el-table-column>
                         <el-table-column prop="stepStart" label="前提条件" align="center" width="200">
                        </el-table-column>
                         <el-table-column prop="stepTarget" label="目标条件" align="center" width="200">
                        </el-table-column>
                          <el-table-column prop="stepTerminal" label="结束条件" align="center" width="200">
                        </el-table-column>
                          <el-table-column prop="score" label="分值" align="center" width="150">
                        </el-table-column>
                         <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="250"
                        >
                         <template slot-scope="scope">
                                    <el-button type="text" size="small"  slot="reference" style="color:red" @click="addData(scope.row,scope.$index,'up')">向上添加</el-button>
                                    <el-button type="text" size="small"  slot="reference" style="color:red" @click="addData(scope.row,scope.$index,'down')">向下添加</el-button>
                                    <el-button type="text" size="small"  slot="reference" style="color:red" @click="editStep(scope.row,scope.$index)">编辑</el-button>
                                     <el-button type="text" size="small"  slot="reference" style="color:red" @click="deletTopic(scope.$index)">删除</el-button>
                                </template>
                         </el-table-column>
                </el-table>
                 </div>
               </div>
        </div>
           <!-- 打开步骤编辑 -->
                 <el-dialog
                    title="编辑步骤"
                    :visible.sync="centerDialogVisible"
                    width="40%"
                    :append-to-body="true"
                    center
                    v-if="centerDialogVisible"
                    >
                      <div class="forminfo"> 
                            <rasoStep  
                            :propData='propData'
                            :propIndex="propIndex"
                            :propAppId="$route.query.appId"
                             @emitFun="handleData"
                            ref="rasoTemplate"
                            ></rasoStep>
                            <div class="authbtn flex align-cen">
                                    <el-button plain  @click="centerDialogVisible = false">取消</el-button>
                                    <el-button type="primary" class="" @click="onSubmit">确认</el-button>
                                </div>
                        </div>
                 </el-dialog>
    </div>
</template>
<script>
import topicSteps from "@/components/topicSteps/index.vue"; //步骤条组件
import rasoStep from "@/components/rasoStep3.vue"; //步骤条组件
import Sortable from "sortablejs";
import {stepImportSave} from "@/api/enterprise/index"   //导入保存
export default {
    name:'importStep',
    components: {
        topicSteps,
        rasoStep
    },
    props: {
    PropType:[String, Number],
  },
    data () {
        return {
            oldIndex: null,
            newIndex: null,
            businessInfo:{},
            loading:false,
            propIndex:'',
            centerDialogVisible:false,
            importTopic:false,
            headers:{},
            itemList:[],
            sortedIndexes:[],
            Eng:['A','B','C','D','E','F','G','H','I','J'],
            propData:{},
            propList:[
            {
                steps:1,
                text:'上传模版',
            },
            {
                steps:2,
                text:'检查考核项',
            },{
                steps:3,
                text:'导入考核项',
            }

        ]
        }
    },
    created () {
                let token = this.$locaStorage.setAge().get('token')
                if(token){
            this.headers = {
                'Authorization': token
            }
        }
    },
    methods: {
        // 返回配置步骤
        returnStep(){
            this.$router.push({
            name:'twoEnRaso',
            query:{
                twoId:this.$route.query.id
            }
            })
        },
        // 导入步骤
        stepSave(){
         this.loading = true;
        stepImportSave(this.itemList)
          .then(res => {
              this.loading = false
              if(res.code == 0){
                 this.$util.Notifi('导入成功','success','fa-check')
                    setTimeout(() => {
                        this.$router.push({
                        name:'twoEnRaso',
                        query:{
                            twoId:this.$route.query.id
                        }
                        })
                            }, 100);
              }else{
                this.$message.error(res.msg)
              }
            })
            .catch(err => {
                 this.loading = false
            })
        },
         // 接收子组件传输数据
        handleData(data,index){
            this.$set(this.itemList, index, data)
            this.centerDialogVisible = false 
        },
        // 编辑步骤
        editStep(item,index){
            this.propData = {...item}
            this.propIndex = index
            this.centerDialogVisible = true
        },
        // 向上向下添加数据
        addData(item,index,type){
            // 数据、索引、向上还是向下
            if(type == 'up'){
                this.itemList.splice(index,0,{...item})
            }else{
                this.itemList.splice(index + 1,0,{...item})
            }
            // 遍历数组，更新sort属性以反映索引（从1开始）  
                this.itemList.forEach((item, i) => {  
                    item.sort = i + 1; 
                });
            
        },
          // 删除步骤
        deletTopic(index){
          this.$confirm('确定要删除该步骤？删除后试卷将不再具备该考核步骤【不会影响之前的考试结果】', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        let delet= this.itemList.filter((item,sy)=> sy != index) 
        this.itemList = delet
        })
        },
        // 导入进入下一步
        openTwoSteps(){
             const encryptQuery = this.$base64.encode(JSON.stringify(this.itemList)) //链接参数加密  
            if(this.itemList.length){
                if(!this.PropType){
                    // 不是组件直接进入第二步
                    this.$router.push({name:'questionTwoSteps',query:{data:encryptQuery,type:this.PropType}})
                }else{ 
                    // 为组件调用先触发父组件事件然后由父组件调用第二步(当作组件调用)
                this.$emit('sendStatus',encryptQuery)
                }
            }else{
             this.$util.Notifi(`无试题，请重新导入试题模版`,'error','fa-exclamation-circle') 
                     this.importTopic = false
            }
        },
        // 取消导入
        cacelIM(){
            this.importTopic = false
        },
        onSubmit(){
              this.$refs.rasoTemplate.emitData()  
        },   
        // 下载模版
        openExcel(){
            window.open(`${this.$config.baseUrl}/admin/statics/template/processStep.xlsx`,'_blank')
        },
        // 文件上传成功
        handleSuccess(res, file){
            this.itemList = []
           if(res.code == 0){
             if(res.data && res.data.length > 0){
              this.itemList = res.data
            this.importTopic = true
            this.$nextTick(() =>{
                 this.init()
            })
             }else{
            this.$util.Notifi(`上传模版有误，请检查`,'error','fa-exclamation-circle') 
             this.$refs.upload.clearFiles(); 
             }
           }else{
            this.$util.Notifi(`${res.msg}`,'error','fa-exclamation-circle') 
             this.$refs.upload.clearFiles();  
           }
        },
            	init(){
		// 1. 获取拖拽元素的父元素
		// 因为使用的element的table 所以可直接获取tbody
		let el =  document.querySelector(".el-table__body-wrapper tbody");
		let _this = this;	
		// 2. 创建并配置相关参数
		var sortable = new Sortable(el, {			
			// 只有按住手柄才能进行拖拽
            handle:'.handle_move',
			// 行拖拽，所以该值设置为行class
			draggable:'.el-table__row', // 允许拖拽的项目类名
            
			// 因为拖拽过程中不尽兴位置调整，所以就要记录拖拽行初始位置以及目标位置
			// 拖拽中 回调函数
			 onMove(customEvent) {
	          // 禁止在拖拽过程中交换位置
	          // 可将初始位置及目标位置进行记录
	          _this.oldIndex = customEvent.dragged.rowIndex; //  初始位置
	          _this.newIndex = customEvent.related.rowIndex; // 目标位置
	          return false;  // 不进行交换
	          // 返回值有三个
	          // return false; — for cancel
	          // return -1; — insert before target
	          // return 1; — insert after target
	        },
			
			// 拖拽结束，调整位置
			onEnd() {
               
	          // 在拖拽结束后，获取初始及目标位置
	          const { newIndex, oldIndex } = _this;
	          const currRow = _this.itemList.splice(oldIndex, 1)[0];
	          _this.itemList.splice(newIndex, 0, currRow);
            for (let i in _this.itemList) {
                _this.itemList[i].sort = Number(i)+1
            }
	          // 拖拽完成，初始位置及目标位置重置
	          _this.newIndex = null;
	          _this.oldIndex = null;
	        },
		})
	},
    },
    destroyed(){
    }
}
</script>
<style lang="scss" scoped>
.handle_move {
  cursor: move;
}
.importTopic{
    width: 100%;
    text-align: center;
    padding-top: 100px;
    box-sizing: border-box;
    .template-text{
        display: flex;
        align-items: center;
    justify-content: center;
    color: #7a8c99;
    font-size: 14px;
    cursor: pointer;
    padding-top: 20px;
.excel-icon{
        display: inline-block;
    width: 20px;
    height: 20px;
    background: url('../../../assets/images/excel-deactivate.svg') center no-repeat;
}
    }
    .tips-text{
   background-color: #f2f9fe;
    padding: 25px 10px 30px 30px;
    margin: 50px 35px 24px;
    text-align: left;
    .title{
        font-size: 18px;
        color: #36aafd;
    line-height: 30px;
    font-weight: normal;
    font-stretch: normal;
    }
    p{
        font-size: 16px;
        line-height: 30px;
    letter-spacing: 0px;
    color: #666666;
    }
    }
}
.public-list-container{
    position: relative;
    .public-list-container-table{
         .pustclass{
            width: 15%;
            text-align: center;
          }
          .stsort{
            width: 40% !important;
            text-align: center;
             overflow: hidden;
                    text-overflow: ellipsis;
                    white-space:nowrap
          }
        .public-list-container-table-row {
            padding: 30px 0 !important;
            .pdd{
                padding-bottom: 30px;
            }
           
        }
        .topicIstru{
                border-top: solid 1px #ccc;
                padding: 30px 10px;
            .duplicate-questions{
                
                .duplicate-question{
                    max-width: 50%;
                    flex: 1 1 50%;
                    padding-right: 15px;
                    padding-left: 15px;
                    margin-bottom: 10px;
                    box-sizing: border-box;
                    .portlet{
                        background: #fafafa;
                        padding: 16px 10px !important;
                        border-radius: 5px;
                        .portlet-head{
                            border-bottom: 0;
                            padding: 0 10px;
                            margin-bottom: 0;
                            color: #fff;
                            .caption{
                               font-size: 16px;
                                color: #333;
                                font-weight: 600;
                                padding: 11px 0 9px 0;
                            }
                            .btn-set{
                                .btn-blue-delete{
                                    font-size: 13px;
                                    line-height: 1.5;
                                    cursor: pointer;
                                    color: #36aafd;
                                    border: 1px solid #36aafd;
                                    padding: 8px 25px !important;
                                    border-radius: 4px !important;
                                    box-sizing: border-box;
                                    margin-right: 5px;
                                }
                                .btn-default{
                                    font-size: 13px;
                                    line-height: 1.5;
                                    cursor: pointer;
                                    color: #fff;
                                    background-color: #36aafd;
                                    padding: 8px 25px !important;
                                    border: 1px solid #36aafd;
                                    border-radius: 4px !important;
                                }
                            }
                        }
                        .portlet-body{
                            padding: 10px;
                            .duplication-info-container{
                                .ques-title {
                                    position: relative;
                                    padding-right: 50px;
                                    font-size: 17px;
                                    vertical-align: middle;
                                    line-height: 1.5;
                                    -webkit-margin-before: 0;
                                    -webkit-margin-after: 0;
                                    word-break: break-word;
                                    .ques-type{
                                      background-color: #387dfe;
                                        color: #fff;
                                        padding: 3px 12px;
                                        border: none;
                                        font-size: 12px;
                                        width: 70px;
                                        text-align: center;
                                    }
                                    .qcotent{
                                        padding: 0 10px;
                                        font-size: 15px;
                                    }
                                    .ques-score{
                                        position: absolute;
                                        top: 0px;
                                        right: 10px;
                                        color: #000;
                                    }
                                }
                                .question-option-list{
                                    padding: 0 20px;
                                    margin-top: 10px;
                                    li{
                                        list-style-type: upper-latin;
                                        margin-bottom: 15px;
                                        font-size: 14px;
                                    }
                                    li::marker{
                                       unicode-bidi: isolate;
                                    font-variant-numeric: tabular-nums;
                                    text-transform: none;
                                    text-indent: 0px !important;
                                    text-align: start !important;
                                    text-align-last: start !important; 
                                    }
                                }
                                .ques-answers{
                                    .test_result{
                                        margin-bottom: 8px;
                                       .rightAnswer{
                                            color: #36aafd;
                                            display: block;
                                            font-size: 16px;
                                       } 
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
::v-deep{
        .authbtn{
        justify-content: center !important;
    }
    .el-dialog{
        margin-top: 5vh !important;
    }
       .el-dialog{
      
            .el-dialog__header{
                background: #ccc;
               border-radius: 2px 2px 0 0;
            }
        }
    .el-upload-dragger{
    background: none;
    border: none;
    height: auto;
   .icon-al-file-fill{
    font-size: 80px;
    color: #C0C4CC;
    margin: 40px 0 16px;
    }
    .el-button{
        margin-top: 30px;
    }
    }
 
}
</style>